if (serverProfile.environment === 'dev') {
  import('./common-style');
}

/* eslint-disable no-undef */
/** @note: under webpack order of loading is sequential */
// {{ relevant after upgrade to webpack5
import { Buffer } from 'buffer';
window.Buffer = Buffer;
// }}
import Marionette from 'backbone.marionette';
import 'jquery';
import 'jquery-ui';
import 'jquery-ui-wochit';
import 'lodash-extended';
import 'backbone.marionette';
import 'bootstrap';
import 'handlebars';
import 'md5';
import 'extension';
import 'helpers';
import 'libs/jquery.ba-outside-events.min';
import 'webfont';
import './util';
import 'lang/en/culture';
import 'vueGlobals';
import 'c/DialogController';
import 'ModalRegion';
import 'm/ApplicationStateModel';
import 'm/AssetModel';
import 'c/IntercomController';
import 'c/AppController';
import 'c/FontController';
import 'c/UndoController';
import 'c/GoogleDrivePickerController';
import 'c/NotificationController';
import 'v/NotificationFeedback.vue';
import 'c/Extension';
import 'l/AppLayout';
import 'm/LocalStorage';
import 'm/RemoteStash';
import 'm/UploadQueue';
import 'cm/ProgrammerCollection';
import 'cm/TokenCollection';
import 'm/TimedExecutor';
import 'm/StoryModel';
import 'c/KeyboardAccessibility';
import 'c/StartPageController';
import 'c/ImportExportController';
import 'c/StoryController';
import 'c/AssetController';
import 'c/VideoController';
import 'c/DoctorController';
import 'c/ConnectionController';
import 'c/RealTimePreviewsController';
import 'c/ExperimentController';
import 'c/FullPreviewPlayerController';
import 'c/AiTasksController';
import 'c/ObjectTrackingController';
import './workpool/job-list';
import ExternalScripts from 'externalScripts';
import MultiloginAdapter from './controllers/MultiloginAdapter';
import BroadcastController from 'c/Broadcast';
import GlobalContext from 'c/GlobalContext';
import RootStore from '#/store/RootStore.js';
import { workPool } from '@wochitnpm/helpers';

if (serverProfile.environment === 'dev') {
  workPool.exposeInWindow();
}

function initAppDependencies(fn) {
  // when context.js done - break from main.js microtask to a new task
  // cause importing modules here takes enormous time
  window.whenContextLoaded.then(() => setTimeout(fn, 0));
}

initAppDependencies(async () => {
  GlobalContext.parse(tk);
  const { default: app } = await import('app');

  app.broadcast = new BroadcastController();
  // noinspection ES6MissingAwait
  app.broadcast.emit('sw-init', {
    maintenanceUrl: serverProfile.maintenanceUrl,
  });
  app.notificationController =
    new app.namespace.Controller.NotificationController({
      userId: tk.context.user.employeeId,
    });
  app.stash = new app.namespace.Model.LocalStorage({
    lsid: 'stash_' + tk.context.user.employeeId,
    autosave: true,
  });

  app.rootStore = new app.Vuex.Store(
    RootStore({
      state: {
        user: tk.context.user,
      },
    })
  );

  app.api.realTime.authenticate();
  app.api.realTime.setAppConfig();

  const storySyncMutex = new app.namespace.Util.Mutex();
  app.api.draftStories.useMutex(storySyncMutex);
  app.api.draftStoriesAutosave.useMutex(storySyncMutex);
  app.api.draftStoryTemplates.useMutex(storySyncMutex);

  app.doctorController = new app.namespace.Controller.DoctorController();
  app.aiTasksController = new app.namespace.Controller.AiTasksController();
  app.objectTrackingController =
    new app.namespace.Controller.ObjectTrackingController();
  app.state = new app.namespace.Model.ApplicationStateModel();

  app.stash.fetch(); // load localStorage stash model
  app.remoteStash = new app.namespace.Model.RemoteStash({
    type: 'userId',
    id: tk.context.user.employeeId,
    autosave: true,
  });

  // eslint-disable-next-line no-constant-condition
  app.remoteStash.fetch();

  // disable console interface except `error` function as soon as possible
  if (
    app.rootStore.getters['user/box'].isProd() &&
    localStorage.debug !== 'true'
  ) {
    for (const prop in console) {
      if (typeof console[prop] === 'function' && prop !== 'error') {
        console[prop] = $.noop;
      }
    }
  }

  app.api.StoryboardSchemas.get()
    .then((schema) => {
      app.linkedFieldsSchema = schema;
    })
    .fail(() => {
      console.error(
        'Failed to retrieve storyboard schema / empty schema retrieved'
      );
    });

  app.programmers = new app.namespace.Collection.ProgrammerCollection();
  app.programmers.add(tk.context.relatedProgrammerList, { parse: true });

  app.keyboardAccessibility =
    new app.namespace.Controller.KeyboardAccessibility({
      enable: true,
    });
  app.startPageController = new app.namespace.Controller.StartPageController();
  app.storyController = new app.namespace.Controller.StoryController();
  app.videoController = new app.namespace.Controller.VideoController();
  app.realTimePreviewController =
    new app.namespace.Controller.RealTimePreviewsController();
  app.experiment = new app.namespace.Controller.Experiment();
  app.UploadQueue = new app.namespace.Collection.UploadQueue();
  app.dialog = new app.namespace.Controller.Dialog();
  app.extensionController = new app.namespace.Controller.Extension();

  app.initDate = Date.now();

  app.controller = new app.namespace.Controller.AppController();
  app.connectionController =
    new app.namespace.Controller.ConnectionController();

  const AppRouter = Marionette.AppRouter.extend({
    // all methods must exist in AppController.js
    appRoutes: {
      '': 'routeDefault',
      'readyMade(/)': 'routeReadyMade',
      'dashboard/:tab(/)': 'routeDashboard',
      'dashboard/versions/:id(/)': 'routeStoryVersions',
      'stories/:id(/)': 'routeStories',
      'stories/:id(/)/edit/:assetEditor/:displayStartTime/:vue': 'routeStories',
      'videos/:id(/)': 'routeVideos',
      'videos/producing/:id(/)': 'routeVideoProducing',
      '*path': 'routeNotFound',
    },
    onRoute: function (name, path, args) {
      // console.log('\u26A1SWITCHING ROUTE', name, path, args);
      app.rootStore.commit('onRouteChanged', Backbone.history.fragment);

      if ('routeNotFound' === name || args[0] === '404') {
        return;
      }

      app.state.set('lastUrl', '/' + Backbone.history.fragment);

      if (Date.now() - app.initDate >= app.TIME.AUTOREFRESH_THRESHOLD) {
        console.log(
          'reloading app due to long time of usage, freeing resources.'
        );
        app.delayedSpinner.show({
          msg: 'Freeing resources,<br>please wait...',
          delay: 0,
        });
        window.location.reload();
        return;
      }

      // clear pop up modals
      app.controller.hideModal();
      $('.wt-modal.in').modal('hide');

      app.analytics('analytics:page');
    },
  });

  app.router = new AppRouter({
    // binding app route with controller
    controller: app.controller,
  });

  if (!app.validate.userIsValid()) {
    return;
  }

  app.on('start', function () {
    console.log(
      `%c\u2721 WOCHIT STUDIO ART - ${performance?.now()}ms`,
      'color: #295622;'
    );
    Backbone.history.start({ pushState: true, root: '/' });

    const originalHistoryFn = Backbone.history.loadUrl;
    Backbone.History.prototype.loadUrl = function () {
      app.rootStore.commit('onRouteChanged', Backbone.history.fragment);

      // eslint-disable-next-line prefer-rest-params
      const urlArgs = arguments;
      // prevent 'back' when asset editor is active
      if (app.checkAssetEditorUrl(Backbone.history.fragment)) {
        app.controller.hideModal();
        app.state.blockNavigation();
        return false;
      } else if (app.state.isNavigationBlocked()) {
        app.dialog
          .confirm(
            {
              type: app.dialog.types.CONFIRM_3,
              title: 'Are you sure?',
              description: 'Changes you made may not be saved',
            },
            {
              wrapperStyle: {
                zIndex: 2100,
              },
            }
          )
          .then((data) => {
            if (data.action) {
              if (!/\/stories\//i.test(location.pathname)) {
                app.state.enableNavigation();
                app.controller.hideModal();
                app.closeModals();
                app.storyController.freeStory();
              }
              originalHistoryFn.apply(this, urlArgs);
            } else {
              history.pushState(null, null, app.state.get('lastUrl'));
            }
          });
      } else {
        return originalHistoryFn.apply(this, urlArgs);
      }
    };

    app.connectionController.start();
  });

  ExternalScripts.loadAll({
    isImpededTemplatizer: app.rootStore.getters['user/isImpededTemplatizer'],
  });

  app.intercomController = new app.namespace.Controller.IntercomController();
  app.intercomController.start();

  app.remoteStash.whenReady.finally(() => {
    new MultiloginAdapter(() => {
      app.start();
    });
  });
});
